module.exports = __webpack_public_path__ + "img/setupabl-min.ed676b0f.jpg";